import { render } from "./Parceiros.vue?vue&type=template&id=3adfc80a&scoped=true"
import script from "./Parceiros.vue?vue&type=script&lang=js"
export * from "./Parceiros.vue?vue&type=script&lang=js"

import "./Parceiros.vue?vue&type=style&index=0&id=3adfc80a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3adfc80a"]])

export default __exports__